import React from "react";
import { DescriptionText } from "@src/packages/chime-ui";

interface SafeHtmlProps {
  html: string;
  center?: boolean;
}

const SafeHtml: React.FC<SafeHtmlProps> = ({ html, center = false }) => {
  return <DescriptionText center={center} dangerouslySetInnerHTML={{ __html: html }} />;
};

export default SafeHtml;
